// @flow

export const REPORT_NAME_MAX_LEN = 50;
export const REPORT_DESCRIPTION_MAX_LEN = 200;
export const DEFAULT_PROMPT_MAX_CHARS = 1000;

export const getPromptMaxChars = (maxPromptCharsFromState) => {
  const n = Number(maxPromptCharsFromState);
  if (Number.isFinite(n) && n > 0) return n;
  return DEFAULT_PROMPT_MAX_CHARS;
};

export const getAiReportsUiModel = ({ inEditMode }) => {
  return {
    mode: inEditMode ? 'edit' : 'create',
    limits: {
      reportNameMaxLen: REPORT_NAME_MAX_LEN,
      reportDescriptionMaxLen: REPORT_DESCRIPTION_MAX_LEN,
      getPromptMaxChars,
    },
    copy: {
      chat: {
        promptPlaceholder: inEditMode
          ? 'How can I help you edit your report?'
          : 'How can I help you create a report?',
      },
      topBar: {
        title: 'Report Designer',
        namePlaceholder: 'Report name',
        descriptionPlaceholder: 'Short description',
        descriptionExpandTooltip: 'Expand to edit',
        descriptionPopoverTitle: 'Edit description',
        descriptionDoneLabel: 'Done',
        save: {
          label: inEditMode ? 'Save' : 'Save',
          tooltip: inEditMode
            ? 'Save your edits to the existing report'
            : 'Save your report to My Reports',
        },
        saveAsNew: {
          label: 'New',
          tooltip:
            'Save your edits to a new report, without changing the existing report',
        },
        cancel: {
          label: 'Cancel',
          tooltip: 'Discard changes and go back',
        },
        reset: {
          label: inEditMode ? 'Reset' : 'New',
          tooltip: inEditMode
            ? 'Reset back to the original report and restart editing'
            : 'Clears current conversation and generated report',
        },
      },
      errors: {
        genericChatToast: 'Something went wrong, please try again.',
      },
    },
  };
};
